import { Component, Inject, Injectable } from '@angular/core';
import {
  MatSnackBar,
  MatSnackBarConfig,
  MatSnackBarHorizontalPosition,
  MatSnackBarVerticalPosition,
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA
} from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';


export enum AlertType {
  Error,
  Success,
  Warning
}

@Component({
  template: `<div class="data.class" [innerHTML]="data.html" (click)="snackBar.dismiss()"></div>`
})
export class ViasAlertComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
    public snackBar: MatSnackBar
    ) { }

}

@Injectable({
  providedIn: 'root'
})
export class ViasAlertService {
  snackBarConfig: MatSnackBarConfig;
  snackBarRef: MatSnackBarRef<any>;
  horizontalPosition: MatSnackBarHorizontalPosition = 'center';
  verticalPosition: MatSnackBarVerticalPosition = 'top';
  snackBarAutoHide = '6000';

  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService
    ) { }


  /**
   * Kullanim
   *
   * this.globals.viasAlert.show(
   *    errorTxt,
   *    AlertType.Error,
   *    ()=>{
   *      alert("acildi");
   *    },
   *    ()=>{
   *      alert("kapandi");
   *    }
   * );
   *
   * @param msgTxt string
   * @param type AlertType
   * @param afterOpenedFunc function
   * @param afterDismissedFunc function
   */
  show(
    msgTxt: string,
    type: AlertType = AlertType.Success,
    afterOpenedFunc: () => void = () => {},
    afterDismissedFunc: () => void = () => {}
  ): void {

    let color = 'green-snackbar';
    switch (type) {
      case AlertType.Error:
        color = 'red-snackbar';
        break;
      case AlertType.Warning:
        color = 'yellow-snackbar';
        break;
      default:
      case AlertType.Success:
        color = 'green-snackbar';
        break;
    }
    this.snackBarConfig = new MatSnackBarConfig();
    this.snackBarConfig.horizontalPosition = this.horizontalPosition;
    this.snackBarConfig.verticalPosition = this.verticalPosition;
    this.snackBarConfig.duration = parseInt(this.snackBarAutoHide, 0);
    this.snackBarConfig.panelClass = color;

    // this.snackBarRef = this.snackBar.open(msgTxt, 'X', this.snackBarConfig);
    this.translate.get(msgTxt).subscribe((translated: string) => {
      msgTxt = translated;
    });
    this.snackBarConfig.data = { html: msgTxt, class: color};
    this.snackBarRef = this.snackBar.openFromComponent(ViasAlertComponent, this.snackBarConfig);
    this.snackBarRef.afterDismissed().subscribe( afterDismissedFunc );
    this.snackBarRef.afterOpened().subscribe( afterOpenedFunc );

  }
}
